<template>
  <div v-if="!!question && !!options">
    <h6>{{ label }}</h6>
    <div class="mb-2" v-html="question.description"></div>
    <b-row
        v-for="(contact, index) in contacts"
        :key="index"
      >
      <b-col :class="options.multiple ? 'col-10' : ''">
        <form-person-question
          :organization="organization"
          :question="question"
          v-model="contacts[index]"
          hide-label
          :size="size"
          :errors="getErrorsForIndex(index)"
          :show-warnings="showWarnings"
        ></form-person-question>
      </b-col>
      <b-col v-if="options.multiple" class="col-2">
        <b-button variant="link" class="text-danger" @click="onClickRemove(index)">
          <i class="fa fa-fw fa-times"></i>
        </b-button>
      </b-col>
    </b-row>
    <b-form-group v-if="options.multiple">
      <b-button variant="link" size="sm" @click="onClickAdd">
        <i class="fa fa-fw fa-plus"></i>
        {{ trans('add') }}
      </b-button>
    </b-form-group>
  </div>
</template>

<script>
  import FormPersonQuestion from './FormPersonQuestion'

  function isEmpty(value) {
    return ((value||'')+'').trim().length == 0
  }

  const blank = {
    first_name: null,
    last_name: null,
    name: null,
    pronouns: null,
    gender: null,
    date_of_birth: null,
    email: null,
    mobile: null,
    other_phone: null,
    address: null,
    zip_postal_code: null,
    relationship: null,
    company: null,
    can_pickup: null,
  }

  export default {
    props: {
      organization: Object,
      value: Array, // answer
      question: Object,
      disabled: {
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        default: 'md',
      },
      errors: {
        type: Array,
        default() {
          return []
        },
      },
      showWarnings: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      FormPersonQuestion,
    },
    data() {
      return {
        trans: trans,
        contacts: _.cloneDeep(this.value && this.value.length ? this.value : []),
      }
    },
    computed: {
      id() {
        return this.value ? this.value.id : undefined
      },
      options() {
        return this.question.options
      },
      label() {
        return this.question.label
      },
      slug() {
        return this.question.slug
      },
      required() {
        return this.question.required
      },
      description() {
        return this.question.description
      },
    },
    watch: {
      contacts: {
        deep: true,
        handler() {
          let contacts = this.serialize()
          if (!_.isEqual(this.value, contacts)) this.$emit('input', contacts)
        },
      },
      value() {
        this.hydrate()
      },
    },
    methods: {
      getErrorsForIndex(index) {
        return this.errors && this.errors[index] ? this.errors[index] : {}
      },
      onClickAdd() {
        this.contacts.push(_.clone(blank))
      },
      onClickRemove(index) {
        this.contacts.splice(index, 1)
      },
      serialize() {
        return _.cloneDeep(this.contacts)
      },
      hydrate() {
        this.contacts = _.cloneDeep(this.value && this.value.length ? this.value : [])
      },
    },
    mounted() {
      this.hydrate()
      window['formQuestionContacts_'+this.id] = this
    },
  }
</script>